/*!
 *  (c)(r) 2008-2025 IT-Service Robert Frunzke
 */

import { startProgress, stopProgress, postToBackend2 } from 'js/entry/base.js';


var m_approver_votes_cache = {};

function queryApproverVotes( voting_id, onresult, error_cb ) {
	startProgress();
	var postdata = 'voting_id='+encodeURIComponent(voting_id);
	postToBackend2(
		'json/x_votings_main/approver_votes-get',
		postdata,
		function _success( j, jqXHR ) {
			stopProgress();
			if( j && j.hasOwnProperty('votes') ) {
				m_approver_votes_cache[voting_id] = { voting_id, changed_dt: j.changed_dt, submitted_dt: j.submitted_dt, votes: j.votes, media_ids: j.media_ids, ts: Date.now() };
				if( onresult ) onresult(j.changed_dt,j.submitted_dt,j.votes,j.media_ids);
			} else {
				if( error_cb ) error_cb(jqXHR,'invalid data','invalid data');
			}
		},
		function _timeout() {
			stopProgress();
		},
		function _error( jqXHR, textStatus, message ) {
			stopProgress();
			if( error_cb ) error_cb(jqXHR,textStatus,message);
		},
		true
		// function _complete( jqXHR, textStatus, self ) {
		// }
	);
}



var m_approver_votes_cache_max_age_ms = 33*1000;

export function queryCachedApproverVotes( voting_id, success_cb, error_cb ) {
	if( m_approver_votes_cache.hasOwnProperty(voting_id) ) {
		var ce = m_approver_votes_cache[voting_id];
		if( Date.now() - ce.ts >= m_approver_votes_cache_max_age_ms ) {
			delete m_approver_votes_cache[voting_id];
		} else {
			setTimeout( function() {
				success_cb(ce.changed_dt,ce.submitted_dt,ce.votes,ce.media_ids);
			}, 0 );
			return;
		}
	}
	return queryApproverVotes(voting_id,success_cb,error_cb);
}


// eslint-disable-next-line import/no-unused-modules
export function clearApproverVotesCache( voting_id ) {
	if( voting_id == null ) m_approver_votes_cache = {};
	else if( m_approver_votes_cache.hasOwnProperty(voting_id) ) delete m_approver_votes_cache[voting_id];
}



/**
 *
 * @param {Object} approver_votes
 * @param {Array} sel_media_ids
 * @returns {?boolean}
 */
export function getApproverVotesCombinedState( approver_votes, sel_media_ids ) {
	var media_id = sel_media_ids[0];
	var last_val = approver_votes.hasOwnProperty(media_id) ? !!approver_votes[media_id] : undefined;
	for( var i=1; i<sel_media_ids.length; ++i ) {
		media_id = sel_media_ids[i];
		const vote_val = approver_votes.hasOwnProperty(media_id) ? !!approver_votes[media_id] : undefined;
		if( vote_val!==last_val ) {
			// mixed result
			return null;
		}
		last_val = vote_val;
	}
	return last_val;
}


export function getAllApproverVotesGroups( list_count, approver_votes ) {
	var counts = {
		all: list_count || 0,
		approved: 0,
		rejected: 0,
		unrated: 0,
	};
	for( const media_id in approver_votes ) {
		if( !approver_votes.hasOwnProperty(media_id) ) continue;
		const vote_value = approver_votes[media_id];
		if( vote_value ) counts.approved ++;
		else counts.rejected ++;
	}
	counts.unrated = counts.all - counts.approved - counts.rejected;
	return counts;
}



function mergeApproverVotes( voting_id, media_ids_to_vote_value, onresult ) {
	startProgress();
	var postdata = 'voting_id='+encodeURIComponent(voting_id);
	for( const media_id in media_ids_to_vote_value ) {
		if( !media_ids_to_vote_value.hasOwnProperty(media_id) ) continue;
		const vote_value = media_ids_to_vote_value[media_id];
		if( vote_value===true || vote_value===false || vote_value==null ) {
			postdata += '&set_votes['+encodeURIComponent(media_id)+']=' + (vote_value==null?'':(vote_value?'1':'0'));
		}
	}
	postToBackend2(
		'json/x_votings_main/approver_votes-merge',
		postdata,
		function _success( j, jqXHR ) {
			stopProgress();
			if( j && j.hasOwnProperty('votes') ) {
				m_approver_votes_cache[voting_id] = { voting_id, changed_dt: j.changed_dt, submitted_dt: j.submitted_dt, votes: j.votes, media_ids: j.media_ids, ts: Date.now() };
				if( onresult ) onresult(j.changed_dt,j.submitted_dt,j.votes,j.media_ids);
			}
		},
		function _timeout() {
			stopProgress();
		},
		function _error( jqXHR, textStatus, message ) {
			stopProgress();
		},
		true
		// function _complete( jqXHR, textStatus, self ) {
		// }
	);
}


export function setApproverVotesValue( voting_id, sel_media_ids, vote_value, onresult ) {
	var media_ids_to_vote_value = {};
	for( var i=0; i<sel_media_ids.length; ++i ) {
		const media_id = sel_media_ids[i];
		media_ids_to_vote_value[media_id] = vote_value==null ? null : !!vote_value;
	}
	mergeApproverVotes(voting_id,media_ids_to_vote_value,onresult);
}


export function submitApproverVotes( voting_id, onresult ) {
	startProgress();
	const postdata = 'voting_id='+encodeURIComponent(voting_id);
	postToBackend2(
		'json/x_votings_main/approver_votes-submit',
		postdata,
		function _success( j, jqXHR ) {
			stopProgress();
			if( j && j.hasOwnProperty('submitted_dt') ) {
				m_approver_votes_cache[voting_id] = { voting_id, changed_dt: j.changed_dt, submitted_dt: j.submitted_dt, votes: j.votes, media_ids: j.media_ids, ts: Date.now() };
				if( onresult ) {
					onresult(j.changed_dt,j.submitted_dt,j.votes,j.media_ids,j.lightbox_object_id);
				}
			}
		},
		function _timeout() {
			stopProgress();
		},
		function _error( jqXHR, textStatus, message ) {
			stopProgress();
		},
		true
		// function _complete( jqXHR, textStatus, self ) {
		// }
	);
}

